import React from 'react';
import { connect } from 'react-redux';
import { ZOOM } from '@/constants';
import { getSelectedSection, createClassName } from '@/helpers';
import svgElementDraggableListener from './svgElementDraggableListener';
import { getSectionControlSize } from '../helpers/general';

const ResizeControl = props => {
  const { cx, cy, r, id, className, svgElementDraggableRef } = props;

  const contolSize = r;
  const controlX = cx - (contolSize / 2);
  const controlY = cy - (contolSize / 2);
  const contorlRX = contolSize / 10;

  return (
    <rect
      style={{ fill: '#007981', cursor: 'pointer' }}
      className={className}
      ref={el => svgElementDraggableRef(el)}
      id={id}
      x={controlX}
      y={controlY}
      width={contolSize}
      height={contolSize}
      rx={contorlRX}
    />
  )
};

const UpperLeftControl = svgElementDraggableListener(ResizeControl);
const UpperRightControl = svgElementDraggableListener(ResizeControl);
const LowerLeftControl = svgElementDraggableListener(ResizeControl);
const LowerRightControl = svgElementDraggableListener(ResizeControl);

export default function svgRectResizable(Component) {
  class SvgRectResizable extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        resizeControlDx: 0,
        resizeControlDy: 0,
        dragDx: 0,
        dragDy: 0,
        dx: 0,
        dy: 0,
        dw: 0,
        dh: 0,
        changedControlId: '',
      };
      this.handleULControlDrag = this.handleULControlDrag.bind(this);
      this.handleULControlDragEnd = this.handleULControlDragEnd.bind(this);

      this.handleURControlDrag = this.handleURControlDrag.bind(this);
      this.handleURControlDragEnd = this.handleURControlDragEnd.bind(this);

      this.handleLRControlDrag = this.handleLRControlDrag.bind(this);
      this.handleLRControlDragEnd = this.handleLRControlDragEnd.bind(this);

      this.handleLLControlDrag = this.handleLLControlDrag.bind(this);
      this.handleLLControlDragEnd = this.handleLLControlDragEnd.bind(this);
    }

    handleULControlDrag(dx, dy) {
      this.setState({
        dx,
        dy,
        resizeControlDx: dx,
        resizeControlDy: dy,
        dw: -dx,
        dh: -dy,
        changedControlId: 'ul',
      });
    }

    handleULControlDragEnd(dx, dy) {
      const { onResize } = this.props;
      onResize(dx, dy, -dx, -dy);
      this.setState({
        dx: 0,
        dy: 0,
        dw: 0,
        dh: 0,
        resizeControlDx: 0,
        resizeControlDy: 0,
        changedControlId: '',
      });
    }

    handleURControlDrag(dx, dy) {
      this.setState({
        dx: 0,
        dy,
        dw: dx,
        dh: -dy,
        resizeControlDx: dx,
        resizeControlDy: dy,
        changedControlId: 'ur',
      });
    }

    handleURControlDragEnd(dx, dy) {
      const { onResize } = this.props;
      const { dw, dh } = this.state;
      onResize(0, dy, dw, dh);
      this.setState({
        dx: 0,
        dy: 0,
        dw: 0,
        dh: 0,
        resizeControlDx: 0,
        resizeControlDy: 0,
        changedControlId: '',
      });
    }

    handleLRControlDrag(dx, dy) {
      this.setState({
        dx: 0,
        dy: 0,
        dw: dx,
        dh: dy,
        resizeControlDx: dx,
        resizeControlDy: dy,
        changedControlId: 'lr',
      });
    }

    handleLRControlDragEnd(dx, dy) {
      const { onResize } = this.props;
      const { dw, dh } = this.state;
      onResize(0, 0, dw, dh);
      this.setState({
        dx: 0,
        dy: 0,
        dw: 0,
        dh: 0,
        resizeControlDx: 0,
        resizeControlDy: 0,
        changedControlId: '',
      });
    }

    handleLLControlDrag(dx, dy) {
      this.setState({
        dx,
        dy: 0,
        resizeControlDx: dx,
        resizeControlDy: dy,
        dw: -dx,
        dh: dy,
        changedControlId: 'll',
      });
    }

    handleLLControlDragEnd(dx, dy) {
      const { onResize } = this.props;
      const { dw, dh } = this.state;
      onResize(dx, 0, dw, dh);
      this.setState({
        dx: 0,
        dy: 0,
        dw: 0,
        dh: 0,
        resizeControlDx: 0,
        resizeControlDy: 0,
        changedControlId: '',
      });
    }

    render() {
      const {
        rectProps,
        id,
        scaleCoef,
        onDrag,
        onDragEnd,
        resizable,
        shield,
        isSectionEdit,
        isSectionSelected
      } = this.props;
      const { x, y, width, height } = rectProps;
      const { resizeControlDx: defaultControlDx, resizeControlDy: defaultControlDy, dragDx: defaultDragDx, dragDy: defaultDragDy, changedControlId } = this.state;
      const dragDx = defaultDragDx / scaleCoef / ZOOM;
      const dragDy = defaultDragDy / scaleCoef / ZOOM;
      const resizeControlDx = defaultControlDx / scaleCoef / ZOOM;
      const resizeControlDy = defaultControlDy / scaleCoef / ZOOM;
      const draggable = true;
      const className = `${createClassName({ draggable })} select-area-dot`;

      let ulControlX;
      let ulControlY;
      let urControlX;
      let urControlY;
      let llControlX;
      let llControlY;
      let lrControlX;
      let lrControlY;
      let resizedSectionX;
      let resizedSectionY;
      let resizedSectionWidth;
      let resizedSectionHeight;
      switch (changedControlId) {
        case 'ul':
          ulControlX = x + resizeControlDx;
          ulControlY = y + resizeControlDy;

          urControlX = x + width;
          urControlY = y + resizeControlDy;

          lrControlX = x + width;
          lrControlY = y + height;

          llControlX = x + resizeControlDx;
          llControlY = y + height;

          resizedSectionX = ulControlX;
          resizedSectionY = ulControlY;
          resizedSectionWidth = width - resizeControlDx;
          resizedSectionHeight = height - resizeControlDy;
          break;
        case 'ur':
          ulControlX = x;
          ulControlY = y + resizeControlDy;

          urControlX = x + width + resizeControlDx;
          urControlY = y + resizeControlDy;

          lrControlX = x + width + resizeControlDx;
          lrControlY = y + height;

          llControlX = x;
          llControlY = y + height;

          resizedSectionX = ulControlX;
          resizedSectionY = ulControlY;
          resizedSectionWidth = width + resizeControlDx;
          resizedSectionHeight = height - resizeControlDy;
          break;
        case 'lr':
          ulControlX = x;
          ulControlY = y;

          urControlX = x + width + resizeControlDx;
          urControlY = y;

          lrControlX = x + width + resizeControlDx;
          lrControlY = y + height + resizeControlDy;

          llControlX = x;
          llControlY = y + height + resizeControlDy;

          resizedSectionX = ulControlX;
          resizedSectionY = ulControlY;
          resizedSectionWidth = width + resizeControlDx;
          resizedSectionHeight = height + resizeControlDy;
          break;
        case 'll':
          ulControlX = x + resizeControlDx;
          ulControlY = y;

          urControlX = x + width;
          urControlY = y;

          lrControlX = x + width;
          lrControlY = y + height + resizeControlDy;

          llControlX = x + resizeControlDx;
          llControlY = y + height + resizeControlDy;

          resizedSectionX = ulControlX;
          resizedSectionY = ulControlY;
          resizedSectionWidth = width - resizeControlDx;
          resizedSectionHeight = height + resizeControlDy;
          break;
        default:
          ulControlX = x + dragDx;
          ulControlY = y + dragDy;
          urControlX = x + width + dragDx;
          urControlY = y + dragDy;
          lrControlX = x + width + dragDx;
          lrControlY = y + height + dragDy;
          llControlX = x + dragDx;
          llControlY = y + height + dragDy;
          resizedSectionX = x;
          resizedSectionY = y;
          resizedSectionWidth = width;
          resizedSectionHeight = height;
          break;
      }
      if (resizedSectionHeight < 0) {
        resizedSectionHeight = resizedSectionHeight * -1;
        resizedSectionY = resizedSectionY - resizedSectionHeight;
      }
      if (resizedSectionWidth < 0) {
        resizedSectionWidth = resizedSectionWidth * -1;
        resizedSectionX = resizedSectionX - resizedSectionWidth;
      }

      const dotWidth = getSectionControlSize({
        sectionWidth: resizedSectionWidth,
        sectionHeight: resizedSectionHeight,
        scaleCoef
      });

      return (
        <>
          <Component
            {...this.props}
            rectProps={{
              x: resizedSectionX,
              y: resizedSectionY,
              width: resizedSectionWidth,
              height: resizedSectionHeight,
            }}
            onDrag={ev => {
              if (onDrag) {
                onDrag(ev);
              }
              this.setState({ dragDx: ev.dx, dragDy: ev.dy });
            }}
            onDragEnd={ev => {
              if (onDragEnd) {
                onDragEnd(ev);
              }
              this.setState({ dragDx: 0, dragDy: 0 });
            }}
          />
          {(isSectionSelected && isSectionEdit) ? (
            null
          ) : resizable && !shield?.isMatrix ? (
            <>
              <UpperLeftControl
                id={`${id}-ul`}
                className={className}
                cx={ulControlX}
                cy={ulControlY}
                r={dotWidth}
                draggable={draggable}
                dragTransforms={this.props.dragTransforms}
                onDrag={({ dx, dy }) => this.handleULControlDrag(dx, dy)}
                onDragEnd={({ dx, dy }) => this.handleULControlDragEnd(dx, dy)}
              />
              <UpperRightControl
                id={`${id}-ur`}
                className={className}
                cx={urControlX}
                cy={urControlY}
                r={dotWidth}
                draggable={draggable}
                dragTransforms={this.props.dragTransforms}
                onDrag={({ dx, dy }) => this.handleURControlDrag(dx, dy)}
                onDragEnd={({ dx, dy }) => this.handleURControlDragEnd(dx, dy)}
              />
              <LowerRightControl
                id={`${id}-lr`}
                className={className}
                cx={lrControlX}
                cy={lrControlY}
                r={dotWidth}
                draggable={draggable}
                dragTransforms={this.props.dragTransforms}
                onDrag={({ dx, dy }) => this.handleLRControlDrag(dx, dy)}
                onDragEnd={({ dx, dy }) => this.handleLRControlDragEnd(dx, dy)}
              />
              <LowerLeftControl
                id={`${id}-ll`}
                className={className}
                cx={llControlX}
                cy={llControlY}
                r={dotWidth}
                draggable={draggable}
                dragTransforms={this.props.dragTransforms}
                onDrag={({ dx, dy }) => this.handleLLControlDrag(dx, dy)}
                onDragEnd={({ dx, dy }) => this.handleLLControlDragEnd(dx, dy)}
              />
            </>
          ) : null}
        </>
      );
    }
  }

  const mapStateToProps = (state, props) => {
    const { core: { sectionsSelection, pages, floatableInputVisible } } = state;
    const { section } = props;
    const isEditModeEnabled = floatableInputVisible;
    const selectedSection = getSelectedSection({ sectionsSelection, pages });
    const isSectionEdit = isEditModeEnabled && section?.id === selectedSection?.id;

    return {
      isSectionEdit,
    };
  };

  return connect(mapStateToProps, null)(SvgRectResizable);
}
